(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media--variants"] && !Shopify.designMode) return;
  try {
    class ProductSlideshowElement extends HTMLElement {
    connectedCallback() {
      this.currentIndex = 0;
      this.slides = Array.from(this.querySelectorAll('.product-media--root'));
      this.thumbs = Array.from(this.querySelectorAll('.product-slideshow--thumb'));

      this.querySelector('.product-slideshow--prev')
        ?.addEventListener('click', () => this.go(-1));
      this.querySelector('.product-slideshow--next')
        ?.addEventListener('click', () => this.go(1));

      this.thumbs.forEach((thumb, i) =>
        thumb.addEventListener('click', () => this.goTo(i))
      );

      // Sync with variant selection fired by the theme
      document.addEventListener('variant:change', (e) => {
        const mediaId = e.detail?.featured_media?.id;
        if (!mediaId) return;
        const idx = this.slides.findIndex((s) => s.dataset.id == mediaId);
        if (idx >= 0) this.goTo(idx);
      });
    }

    go(dir) {
      this.goTo(
        (this.currentIndex + dir + this.slides.length) % this.slides.length
      );
    }

    goTo(index) {
      this.slides[this.currentIndex]?.setAttribute('data-active', 'false');
      this.thumbs[this.currentIndex]?.setAttribute('data-active', 'false');
      this.currentIndex = index;
      this.slides[this.currentIndex]?.setAttribute('data-active', 'true');
      this.thumbs[this.currentIndex]?.setAttribute('data-active', 'true');
    }
  }

  customElements.define('product-slideshow-element', ProductSlideshowElement);
  } catch(e) { console.error(e); }
})();

})();
